import Nullstack from 'nullstack';
export default function IconSortDescending2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-sort-descending-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "5",
    y: "5",
    width: "5",
    height: "5",
    rx: ".5"
  }), "   ", Nullstack.element("rect", {
    x: "5",
    y: "14",
    width: "5",
    height: "5",
    rx: ".5"
  }), "   ", Nullstack.element("path", {
    d: "M14 15l3 3l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M17 18v-12"
  }), " ");
}